import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMail = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 12C4 9.79063 5.79063 8 8 8H32C34.2062 8 36 9.79063 36 12V28C36 30.2062 34.2062 32 32 32H8C5.79063 32 4 30.2062 4 28V12ZM6 12V14.4937L18.225 23.4562C19.2813 24.2312 20.7187 24.2312 21.775 23.4562L34 14.4937V12C34 10.8937 33.1063 10 32 10H7.94375C6.89562 10 5.94375 10.8937 5.94375 12H6ZM6 16.975V28C6 29.1063 6.89562 30 8 30H32C33.1063 30 34 29.1063 34 28V16.975L22.9562 25.0688C21.1937 26.3625 18.8062 26.3625 17.0437 25.0688L6 16.975Z" })
});
export default SvgMail;
